import React from 'react';
import {observer} from "mobx-react";
import {GamesOpenSessionRecordFieldLabelBox} from "./boxes/field-label/games-open-session-record-field-label.box";
import {GamesOpenSessionRecordFieldValueBox} from "./boxes/field-value/games-open-session-record-field-value.box";

interface GamesOpenSessionRecordFieldComponentProps {
    label: string;
    value: string;
}
export const GamesOpenSessionRecordFieldComponent: React.FC<GamesOpenSessionRecordFieldComponentProps> =  observer((props) => {
    return (
        <>
            <GamesOpenSessionRecordFieldLabelBox>
                {props.label}
            </GamesOpenSessionRecordFieldLabelBox>
            <GamesOpenSessionRecordFieldValueBox>
                {props.value}
            </GamesOpenSessionRecordFieldValueBox>
        </>
    )
})